import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.slack-verification', {
        url: '/slackverification?vkey',
        component: 'slackVerification',
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/public/verification/slack/slack-verification.state.js